<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
    </form>
</nav>

<div class="animated fadeIn container-fluid">
    <app-rechazostraces-parte-i [tracesParteI]="tracesParteI" [formGroup]="formGroup.get('basic')" (back)="onBack()" (download)="onDownload($event)" [isRechazo]="isRechazo"></app-rechazostraces-parte-i>
</div>
